
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M14 12a2 2 0 1 1-3.999.001A2 2 0 0 1 14 12zM14 5a2 2 0 1 1-3.999.001A2 2 0 0 1 14 5zM14 19a2 2 0 1 1-3.999.001A2 2 0 0 1 14 19z"}})])
      }
    
      }
    